import { Button, Modal, message } from 'antd'
import { useContext, useEffect, useReducer as _useReducer, useRef, useState } from 'react'
import SegmentContext from '@/components/SegmentHelpers/hooks/createContext'
import './index.less'
import {
  imageToBase64,
  sitckersToResultMask,
  stickToHighLightMask
} from '@/components/SegmentHelpers/maskUtils'
import { saveResult } from '@/server'
import { useAppSelector } from '@/hooks'
/* @ts-ignore */
import html2canvas from 'html2canvas'
const ResultArea = () => {
  const {
    image: [image],
    resultMask: [resultMask, setResultMask],
    resultHighlightMask: [resultHighlightMask, setResultHighlightMask],
    isChanging: [isChanging, setIsChanging],
    stickers: [stickers]
  } = useContext(SegmentContext)!
  const imageId = useAppSelector((state) => state.analysisImageInfo.imageId)
  const userId = useAppSelector((state) => state.login.userId)
  const [loading, setLoading] = useState(false)
  const [actualWidth, setActualWidth] = useState<number>(0)
  const [actualHeight, setActualHeight] = useState<number>(0)
  const [legends, setLegends] = useState<any>([])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [viewportWidth, setViewportWidth] = useState<number>(window.innerWidth)
  const [viewportHeight, setViewportHeight] = useState<number>(window.innerHeight)
  const imgRatio = 70
  const containerRef = useRef<HTMLDivElement>(null)
  const handleMouseHoverTag = (sticker: any) => {
    if (image) {
      setResultHighlightMask(stickToHighLightMask(sticker, image.width, image.height))
    }
  }

  const handleMouseOutTag = () => {
    setResultHighlightMask(null)
  }
  const handleLegends = () => {
    const len = stickers.length
    const num = 25
    const results: any = []
    let cnt = 0
    // console.log("len", len)
    // console.log(Math.floor(len / num) + 1)
    for (let i = 0; i < Math.floor(len / num) + 1; i++) {
      const tmp: any = []
      for (let k = 0; k < num; k++) {
        if (cnt == len) break
        tmp.push(stickers[cnt])
        cnt++
        // console.log("cnt", cnt)
      }
      // if (cnt == len) break
      // console.log(tmp)
      if (tmp.length > 0) results.push(tmp)
    }
    console.log('legends:', results)
    setLegends(results)
  }
  const handleSave = async () => {
    setLoading(true)
    const data = stickers.map((sticker) => {
      let name = sticker.name
      if (name == null) name = 'undefined'
      return { ...sticker, img: imageToBase64(sticker.img), name: name }
    })
    saveResult({ data: data, name: `${imageId}_${userId}.png` })
      .then((_response: any) => {
        setIsChanging(false)
        setLoading(false)
        message.success({
          content: '保存成功!'
        })
      })
      .catch((error) => {
        setLoading(false)
        message.warning({
          content: '保存失败！' + error
        })
      })
  }
  const exportImages = () => {
    if (containerRef.current) {
      html2canvas(containerRef.current).then((canvas: any) => {
        const link = document.createElement('a')
        link.href = canvas.toDataURL()
        link.download = `${imageId}`
        link.click()
      })
    }
  }
  const showModal = () => {
    setIsModalOpen(true)
  }

  const handleOk = () => {
    exportImages()
    setIsModalOpen(false)
  }

  const handleCancel = () => {
    setIsModalOpen(false)
  }
  useEffect(() => {
    if (stickers.length > 0 && image) {
      // console.log('draw result mask', stickers)
      setResultMask(sitckersToResultMask(stickers, image.width, image.height))
      handleLegends()
    }
  }, [stickers])
  useEffect(() => {
    setViewportWidth(window.innerWidth)
    setViewportHeight(window.innerHeight)
  }, [window.innerWidth])
  useEffect(() => {
    if (!image) return
    const imageAspectRatio = image.width / image.height
    // console.log(imageAspectRatio)
    const screenAspectRatio = window.innerWidth / window.innerHeight
    let calculatedWidth, calculatedHeight
    if (imageAspectRatio > screenAspectRatio) {
      calculatedWidth = Math.min((viewportWidth * imgRatio) / 100, image.width)
      calculatedHeight = calculatedWidth / imageAspectRatio
    } else {
      calculatedHeight = Math.min((viewportHeight * imgRatio) / 100, image.height)
      calculatedWidth = calculatedHeight * imageAspectRatio
    }
    setActualWidth(calculatedWidth)
    setActualHeight(calculatedHeight)
  }, [viewportWidth, image])
  return (
    <div className='result-row'>
      <h4>标注结果</h4>
      <div className='result-container'>
        <div className='left-column'>
          {image && <img src={image.src} />}
          {resultMask && <img className='result-mask' src={resultMask.src} />}
          {resultHighlightMask && <img className='result-mask' src={resultHighlightMask.src} />}
        </div>
        <div className='result-dash'></div>
        <div className='right-column'>
          <div className='legend-row'>
            <h4>图例</h4>
            <div className='legend-container'>
              {stickers.map((sticker: any, index: number) => {
                return (
                  <div
                    key={index}
                    className='block-row'
                    onMouseOver={() => handleMouseHoverTag(sticker)}
                    onMouseOut={handleMouseOutTag}
                  >
                    <span
                      style={{
                        backgroundColor: `rgb(${sticker.color[0]},${sticker.color[1]},${sticker.color[2]})`
                      }}
                    ></span>
                    <div className='span-text'>{sticker.name}</div>
                  </div>
                )
              })}
            </div>
            <Button onClick={showModal} disabled={image ? false : true}>
              导出结果图
            </Button>
            <Button loading={loading} onClick={handleSave} disabled={isChanging ? false : true}>
              保存
            </Button>
          </div>
        </div>
        {image && (
          <Modal
            title='导出结果'
            open={isModalOpen}
            onOk={handleOk}
            onCancel={handleCancel}
            centered
            bodyStyle={{ height: actualHeight }}
            width={
              stickers.length > 0
                ? actualWidth + legends.length * window.innerWidth * 0.1
                : actualWidth + 50
              // actualWidth + legends.length * 200
            }
            footer={[
              <Button key='cancel' onClick={handleCancel}>
                取消
              </Button>,
              <Button key='ok' type='primary' onClick={handleOk}>
                确定
              </Button>
            ]}
          >
            <div ref={containerRef} className='model-container'>
              <div className='img-row' style={{ width: actualWidth, height: actualHeight }}>
                {image && (
                  <img
                    src={isModalOpen ? imageToBase64(image) : image.src}
                    // src={image.src}
                    style={{ width: actualWidth, height: actualHeight }}
                  />
                )}
                {resultMask && (
                  <img
                    src={resultMask.src}
                    style={{ width: actualWidth, height: actualHeight, opacity: 0.4 }}
                  />
                )}
              </div>
              <div className={`${stickers.length > 0 ? 'legend-row' : 'legend-row-hidden'}`}>
                <h4>图例</h4>
                <div className='legend-container' style={{ height: actualHeight }}>
                  {legends.length > 0 &&
                    legends.map((items: any) => {
                      return (
                        <div className='legend-container-row'>
                          {items.map((sticker: any) => {
                            return (
                              <div className='sticker-container'>
                                <span
                                  style={{
                                    backgroundColor: `rgb(${sticker.color[0]},${sticker.color[1]},${sticker.color[2]})`,
                                    width: '1.5vw',
                                    height: '1vw',
                                    opacity: 0.4,
                                    flexShrink: 0
                                  }}
                                ></span>
                                <span className='span-text'>{sticker.name}</span>
                              </div>
                            )
                          })}
                        </div>
                      )
                    })}
                </div>
              </div>
            </div>
          </Modal>
        )}
      </div>
    </div>
  )
}
export default ResultArea
